// extracted by mini-css-extract-plugin
module.exports = {"change-password-modal":"ChangePasswordModal_change-password-modal__2SxV4"};